<canvas #canv
        (mousedown)="handleMouseDown($event)" (mousemove)="handleMouseMove($event)"
        (touchstart)="handleTouchStart($event)" (touchmove)="handleTouchMove($event)"
>
</canvas>
<div style="pointer-events: none;position: absolute; top:50%; left: 50%; transform: translate(-50%,-50%);" *ngIf="isEmpty">
  <i class="fa-duotone fa-solid fa-signature fa-3x"></i>
  <i class="fa-duotone fa-solid fa-pen fa-2x"></i>
</div>
